import HTTP from '../libs/HTTP';

//query接口请求参数
export interface RequirementQueryParam {
    id?: number,
    companyId?: number,
    salesId?: number,
    states?: number[],
    beginTime?: string,
    endTime?: string,
}
export interface RequirementListRequest {
    requirementQueryParam: RequirementQueryParam,
    pageNo: number,
    pageSize: number,
}

//query接口返回参数
export interface IRequirementInfoList {
    records: IRequirementInfo[],
    total: number,
    size: number,
    current: number,
    pages: number,
}
export interface IRequirementInfo {
    id: number,
    name: string,
    sales: number, 
    salesName: string,
    companyId: number,
    companyName: string,
    customer: number, 
    customerName: string, 
    introduction?: string | null,
    deliveryTime? : number | null, 
    budget? : number | null, 
    states: number, 
    createTime: number,
}

export interface IRequirementSalesOption {
    id: number;
    name: string;
    type?: string;
}

//add接口请求参数
export interface RequirementPostParam {
    name: string,
    companyId?: number,
    companyName?: string,
    customer?: number,
    customerName?: string,
    sales?: number,
    introduction?: string | null,
    deliveryTime? : number | null, 
    budget? : number | null, 
    states: number, 
}

//edit接口请求参数
export interface RequirementPutParam {
    id: number,
    name: string,
    customer: number,  
    introduction?: string | null,
    deliveryTime? : number | null, 
    budget? : number | null, 
    states: number, 
}


class RequirementService extends HTTP {
    //查询需求模块销售筛选项（内部销售+外部销售）
    async getRequirementSalesOptions() {
        const response = await this.get('/requirement/getRequirementSalesOptions');
        if (response) {
            return response.data;
        }
    }

    //根据条件查询需求信息
    async getRequirementListInfo(request: RequirementListRequest) {
        const response = await this.post('/requirement/getRequirement', request.requirementQueryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //根据公司Id查询需求信息
    async getRequirementByCompanyId(request: RequirementListRequest) {
        const response = await this.post(`/requirement/getRequirementByCompanyId/${request.requirementQueryParam.companyId}`, request.requirementQueryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //根据条件查询登录账号的需求信息
    async getRequirementByLoginAccount(request: RequirementListRequest) {
        const response = await this.post('/requirement/getRequirementByLoginAccount', request.requirementQueryParam, {
            params: {
                pageNo: request.pageNo,
                pageSize: request.pageSize,
            },
        });
        if (response) {
            return response.data;
        }
    }

    //根据id查询客户沟通信息
    async getRequirementById(id: number) {
        const response = await this.get(`/requirement/getRequirementById/${id}`);
        if (response && response.data) {
            return response.data;
        }
    }

    //添加客户沟通信息
    async addRequirement(request: RequirementPostParam) {
        const response = await this.post('/requirement/addRequirement', request, {
            params: {
                companyId: request.companyId,
                companyName: request.companyName,
                name: request.name,
                customer: request.customer,
                customerName: request.customerName,
                sales: request.sales,
                introduction: request.introduction,
                delivery_time: request.deliveryTime, 
                budget: request.budget, 
                states: request.states, 
            },
        });
        if (response) {
            return response.data;
        }
    }

    //编辑客户沟通信息
    async updateRequirement(request: RequirementPutParam) {
        const response = await this.put(`/requirement/updateRequirement/${request.id}`, request, {
            params: {
                name: request.name,
                customer: request.customer,
                introduction: request.introduction,
                delivery_time: request.deliveryTime, 
                budget: request.budget, 
                states: request.states, 
            },
        });
        if (response) {
            return response.data;
        }
    }

}
export default new RequirementService();
